export default __webpack_public_path__ + "static/media/ret-res14.ba3269f0.jpg";